import type { ReactNode } from "react";
import { Box, Typography } from "@mui/material";

const lineSx = {
  display: "block",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
} as const;

type StackedDatagridCellProps = {
  primary: ReactNode;
  secondary: ReactNode;
  align?: "left" | "right";
  primaryBold?: boolean;
};

export default function StackedDatagridCell({
  primary,
  secondary,
  align = "left",
  primaryBold = false,
}: StackedDatagridCellProps) {
  return (
    <Box sx={{ minWidth: 0, lineHeight: 1.35, textAlign: align }}>
      <Box
        component="span"
        sx={{
          ...lineSx,
          ...(primaryBold ? { fontWeight: 600 } : {}),
        }}
      >
        {primary}
      </Box>
      <Typography component="span" variant="caption" color="text.secondary" sx={lineSx}>
        {secondary}
      </Typography>
    </Box>
  );
}
